export default "__VITE_ASSET__DsHx27aw__"